// Tables on a phone (client, 2026-10-30: "mobile app ke hisab se screens sahi
// nahi hai, properly fitted nahi hai"). Every list page draws its records as
// a desktop table 750–1800px wide; on a 390px phone that meant swiping
// sideways to read one row. Below 640px each row becomes a card instead: this
// labels every cell with its column's heading (data-label) and marks the table
// `zx-cards`; styles/index.css lays it out. Desktop is untouched.
//
// Only real data tables are changed — a <thead> with at least two headings.
// Opt a table out with data-keep-table on it or on any ancestor.

const PHONE = '(max-width: 639px)';
const CARD_CLASS = 'zx-cards';

function headingsOf(table: HTMLTableElement): string[] | null {
  const rows = table.tHead?.rows;
  if (!rows || rows.length === 0) return null;
  const row = rows[rows.length - 1];
  const labels: string[] = [];
  for (const th of Array.from(row.cells)) {
    const text = (th.getAttribute('aria-label') || th.textContent || '').replace(/\s+/g, ' ').trim();
    for (let i = 0; i < Math.max(1, th.colSpan); i += 1) labels.push(text);
  }
  return labels.filter(Boolean).length >= 2 ? labels : null;
}

function label(table: HTMLTableElement) {
  if (table.closest('[data-keep-table]')) return;
  const labels = headingsOf(table);
  if (!labels) { table.classList.remove(CARD_CLASS); return; }
  table.classList.add(CARD_CLASS);
  for (const section of [...Array.from(table.tBodies), ...(table.tFoot ? [table.tFoot] : [])]) {
    for (const row of Array.from(section.rows)) {
      let col = 0;
      for (const cell of Array.from(row.cells)) {
        // A cell spanning most of the row (an empty-state or detail row) gets no label.
        const want = cell.colSpan > 1 && cell.colSpan >= labels.length - 1 ? '' : (labels[col] ?? '');
        if (cell.getAttribute('data-label') !== want) cell.setAttribute('data-label', want);
        col += Math.max(1, cell.colSpan);
      }
    }
  }
}

function labelAll() {
  if (!window.matchMedia(PHONE).matches) return;
  document.querySelectorAll('table').forEach((t) => label(t as HTMLTableElement));
}

let scheduled = false;
function schedule() {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(() => { scheduled = false; labelAll(); });
}

/** Starts labelling tables for the phone layout; safe to call once at startup. */
export function installMobileTables() {
  if (typeof window === 'undefined' || typeof MutationObserver === 'undefined') return;
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  window.matchMedia(PHONE).addEventListener?.('change', schedule);
  schedule();
}
